const childRoutes = (prop) => [
    {
        path: 'registration-list',
        name: prop + '.registration_list',
        meta: { auth: true },
        component: () => import('../pages/registration-list/List.vue')
    },
    {
        path: 'recommended-list',
        name: prop + '.recommended_list',
        meta: { auth: true },
        component: () => import('../pages/recommended-list/List.vue')
    },
    {
        path: 'approved-list',
        name: prop + '.approved_list',
        meta: { auth: true },
        component: () => import('../pages/approved-list/List.vue')
    },
    {
        path: 'job-fair-circulation',
        name: prop + '.job_fair_circulation',
        meta: { auth: true },
        component: () => import('../pages/job-fair-circulation/List.vue')
    },
    {
        path: 'job-fair-circulation-form',
        name: prop + '.job_fair_circulation_form',
        meta: { auth: true },
        component: () => import('../pages/job-fair-circulation/Form.vue')
    },
    {
        path: 'job-fair-circulation-details',
        name: prop + '.job_fair_circulation_details',
        meta: { auth: true },
        component: () => import('../pages/job-fair-circulation/Details.vue')
    },
    {
        path: 'applicant-list',
        name: prop + '.applicant_list',
        meta: { auth: true },
        component: () => import('../pages/applicant-list/List.vue')
    },
    {
        path: 'applicant-list-details',
        name: prop + '.applicant_list_details',
        meta: { auth: true },
        component: () => import('../pages/applicant-list/Details.vue')
    },
    {
        path: 'sorting-application',
        name: prop + '.sorting_application',
        meta: { auth: true },
        component: () => import('../pages/sorting-application/List.vue')
    },
    {
        path: 'sorting-application-form',
        name: prop + '.sorting_application_form',
        meta: { auth: true },
        component: () => import('../pages/sorting-application/Form.vue')
    },
    {
        path: 'sorting-application-details',
        name: prop + '.sorting_application_details',
        meta: { auth: true },
        component: () => import('../pages/sorting-application/Details.vue')
    },
    {
        path: 'employee-wise-cv-report',
        name: prop + '.employee_wise_cv_report',
        meta: { auth: true },
        component: () => import('../pages/employee-wise-cv-report/List.vue')
    },
    {
        path: 'report/circular-wise-cv-report',
        name: prop + '.circular_wise_cv_report',
        meta: { auth: true },
        component: () => import('../pages/circular-wise-cv-report/List.vue')
    },
    {
        path: 'job-confirmation-list',
        name: prop + '.job_confirmation_list',
        meta: { auth: true },
        component: () => import('../pages/job-confirmation-list/List.vue')
    },
    {
        path: 'direct-apply-for-job',
        name: prop + '.direct_apply_for_job_form',
        meta: { auth: true },
        component: () => import('../pages/direct-apply-for-job/Form.vue')
    },
    {
        path: 'cv-bank',
        name: prop + '.cv_bank',
        meta: { auth: true },
        component: () => import('../pages/cv-bank/List.vue')
    },
    {
        path: 'cv-bank-form',
        name: prop + '.cv_bank_form',
        meta: { auth: true },
        component: () => import('../pages/cv-bank/Form.vue')
    },
    {
        path: 'cv-bank-details',
        name: prop + '.cv_bank_details',
        meta: { auth: true },
        component: () => import('../pages/cv-bank/Details.vue')
    },
    {
        path: 'cv-view',
        name: prop + '.cv_view',
        meta: { auth: true },
        component: () => import('../pages/job-confirmation-list/Details.vue')
    },
    {
        path: 'job-confirmation-report',
        name: prop + '.job_confirmation_report',
        meta: { auth: true },
        component: () => import('../pages/job-confirmation-report/List.vue')
    }
]

const routes = [{
    path: '/awareness-event-service/job-fair-management',
    name: 'awareness_event_service.job_fair_management',
    component: () => import('@/layouts/AwarenessEventLayout.vue'),
    meta: { auth: true },
    children: childRoutes('awareness_event_service.job_fair_management')
}]

export default routes
